export default function Accounts() {
  return <div>User Account Management</div>
}
